import { Outlet } from "react-router-dom";
import TopNavBar from "../pages/TopNavBar";
import BottomNavBar from "../components/BottomNavBar";

export default function MainLayout() {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <TopNavBar />
      <main className="flex-1 overflow-y-auto pb-24">
        <Outlet />
      </main>
      <BottomNavBar isHomeScreen={true} />
    </div>
  );
}